<div class="component" data-automation-e2e-selector="trancheOrdersTable">
  <span
    class="noOrders"
    [hidden]="!(emptyMessage | async)"
    [textContent]="emptyMessage | async"
    data-automation-e2e-selector="trancheOrdersEmptyMessagePlaceholder"
  >
  </span>
  <div [hidden]="emptyMessage | async" class="tableWrapper">
    <ag-grid-angular
      class="ag-theme-cupcake style-height-width-100"
  
      [columnDefs]="columnDefs"
      [animateRows]="true"
      [sortingOrder]="sortingOrder"
      (gridReady)="onGridReady($event)"
      [rowModelType]="'infinite'"
      [enableServerSideSorting]="true"
      [suppressRowHoverHighlight]="true"
      [cacheBlockSize]="50"
    >
    </ag-grid-angular>
  </div>
</div>
